<template>
    <img @click="$emit('click', $event)"
         class="rounded cover-img"
         :height="height" :width="width"
         :src="src"
    />
</template>

<script>
    export default {
        name: "ImageThumbnail",
        props: {
            src: {
                type: String,
                required: true
            },
            height: {
                type: String,
                default: '100rem'
            },
            width: {
                type: String,
                default: '100rem'
            }
        }
    }
</script>

<style scoped>

</style>
